import AllPosts from "./AllPosts";

export default AllPosts;
